module.exports = __webpack_public_path__ + "img/icon-avoid-restart.aa79c205.svg";